<template>
	<div>
		<div style="margin-top: 25px;">
			<el-row :gutter="12">
				<el-col :span="4">
					<el-button @click="allConfirm(1)" type="danger" style="margin-left: 3px;">禁用</el-button>
					<el-button @click="allConfirm(0)" type="success" style="margin-left: 3px;">恢复</el-button>
				</el-col>
				<el-col :span="20">
					<div style="width: 100%;text-align: right;">
						<el-select style="width: 110px;" v-model="selectValue">
							<el-option label="手机号" value="1"></el-option>
						</el-select>
						<el-input type="text" style="width: 235px;margin-left: 3px;" v-model="queryValue" placeholder="请输入"></el-input>
						<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 15px;">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%" element-loading-text="数据正在加载中" @selection-change="handleSelectionChange"
			  :row-style="rowClass">
				<el-table-column type="selection" width="50"></el-table-column>
                <el-table-column label="账户">
					<template slot-scope="scope">
						<div>
							<span>{{interceptUserName(scope.row.username)}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="昵称"></el-table-column>
				<el-table-column prop="name" label="角色">
					<template slot-scope="scope">
						<div>
							<span>{{getRoleName(scope.row.role,scope.row.isAdmin)}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="companyName" label="公司名称"></el-table-column>
				<el-table-column prop="posttime" label="注册时间" :formatter="dateFormat"></el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<div>
							<span>{{scope.row.del?"禁用":"正常"}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<button @click="updatePwd(scope.row.uid)">修改密码</button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background style="text-align:right;margin-top: 15px;margin-bottom: 55px;" @size-change="handleSizeChange"
			 @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize"
			 layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'

	export default {
		name: 'userManagementForBrand',
		components: {},
		data() {
			return {
				selectValue: '1',
				total: 0,
				currentPage: 1,
				pageSize: 10,
				tableData: [],
				multipleSelection: [],
				queryValue: ""
			}
		},
		watch: {},
		mounted() {
			var thiz = this;
			axios.get(this.$store.getters.getApiValue + '/srsUser/getMyData.do').then(function(response) {
				var data = response.data;
				if (data.status == "200") {
					if (data.data.role == "2" || data.data.role == "3") {
						thiz.isAgent = true;
					} else if (data.data.role == "4") {
						thiz.isBrand = true;
					}
				} else {
					thiz.$message.error(data.message);
				}
			}).catch(function(error) {
				thiz.$message.error("系统异常，请与管理员联系!");
				console.log(error);
			});
			this.updateTable();
		},
		beforeDestroy() {},
		methods: {
			updatePwd(ouid) {
				var thiz = this;
				this.$prompt('请输入新密码', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(({value}) => {
					console.log("输入密码："+value);
					axios.get(thiz.$store.getters.getApiValue + '/srsUser/updatePwd.do', {
						params: {
							ouid: ouid,
							password: value
						}
					}).then(function(response) {
						var data = response.data;
						if (data.status == "200") {
							thiz.$message.success("操作成功!");
						} else {
							thiz.$message.error(data.message);
						}
					}).catch(function(error) {
						thiz.$message.error("系统异常，请与管理员联系!");
						console.log(error);
					});
				}).catch(() => {});
			},
			allConfirm(flag) {
				var ids = "";
				for (var i = 0; i < this.multipleSelection.length; i++) {
					debugger
					ids = ids + (i != 0 ? "," : "") + this.multipleSelection[i].uid;
				}
				if (ids.length <= 0) {
					this.$message.error("请选择待操作的用户!");
					return;
				}
				var thiz = this;
				var str = "";
				if (flag == 0) {
					str = "确认批量恢复勾选用户吗?"
				} else {
					str = "确认批量禁用勾选用户吗?"
				}
				this.$confirm(str)
					.then(_ => {
						axios.get(thiz.$store.getters.getApiValue + '/srsUser/updateDel.do', {
							params: {
								ouids: ids,
								del: flag
							}
						}).then(function(response) {
							var data = response.data;
							if (data.status == "200") {
								thiz.$message.success("操作成功!");
								thiz.updateTable();
							} else {
								thiz.$message.error(data.message);
							}
						}).catch(function(error) {
							thiz.$message.error("系统异常，请与管理员联系!");
							console.log(error);
						});
					}).catch(_ => {});
			},
            interceptUserName(username){
                var index=username.lastIndexOf("_");
                username=username.substring(index+1,username.length);
                return username;
            },
			getRoleName(roleid,isAdmin) {
				var roleName = "";
				switch (roleid) {
					case 0:
						roleName = "注册用户";
						break;
					case 1:
						roleName = "终端客户";
						break;
					case 2:
						roleName = "二级代理商";
						break;
					case 3:
						roleName = "一级代理商";
						break;
					case 4:
						roleName =isAdmin===1? "品牌商管理员":"品牌商";
						break;
					case 5:
						roleName = "安装师傅";
						break;
                    case 8:
						roleName = "三级代理商";
                        break;
                    case 9:
						roleName = "运营商";
                        break;
                    case 10:
						roleName = "推广人员";
						break;
					default:
						break;
				}
				return roleName;
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			returnTableChange(val) {
				this.returnSelection = val;
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.updateTable();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.updateTable();
			},
			updateTable() {
				var params = {
					agentId:-1,
					pageId: this.currentPage,
					size: this.pageSize
				};
				if (this.queryValue != "") {
					params.key = this.queryValue
				}
				const loading = this.$loading({
					lock: true,
					text: '获取表格数据中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				setTimeout(() => {
					loading.close();
				}, 3000);
				var thiz = this;
				axios.get(this.$store.getters.getApiValue + '/srsUser/list.do', {
					params: params
				}).then(function(response) {
					loading.close();
					var data = response.data;
					if (data.status == "200") {
						thiz.total = data.totalCount;
						thiz.tableData = data.data;
					} else {
						thiz.$message.error(data.message);
					}
				}).catch(function(error) {
					loading.close();
					thiz.$message.error("系统异常，请与管理员联系!");
					console.log(error);
				});
			},
			dateFormat(row, column, cellValue, index) {
				var str = cellValue;
				if (str == null || str == "") {
					return "";
				} else {
					return this.getStandardDate(new Date(str));
				}
			},
			getStandardDate(val) {
				var year = val.getFullYear();
				var month = val.getMonth() + 1;
				var day = val.getDate();
				month = month < 10 ? "0" + month : month;
				day = day < 10 ? "0" + day : day;
				return year + "-" + month + "-" + day;
			},
			rowClass({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 == 0) {
					return 'background:#F1F2F7;'
				} else {
					return 'background:white;'
				}
				return ''
			}
		}
	}
</script>

<style>
	.el-table {
		font-size: 12px;
		border-bottom: 1px solid #dcd8d8;
		color: black;
	}

	.el-table tr th {
		border-top: 0px;
		border-left: 0px;
		border-right: 0px;
	}

	.el-table tr td {
		border-bottom: 1px solid #dcd8d8;
	}

	.tdClassForAccount {
		padding-left: 10px;
	}

	.imgDiv .commodityImg {
		width: 120px;
		height: 120px;
	}
</style>
